module.exports = __webpack_public_path__ + "img/perfect.4765c7e8.png";